<template>
    <v-card class="OpportunityDialog">
        <v-toolbar flat color="deep-purple darken-4" dark>
            <v-toolbar-title>Opportunité</v-toolbar-title>
            <v-spacer />

            <v-icon
                class="clickable"
                @click.stop="close"
                right
            >mdi-close</v-icon>
        </v-toolbar>

        <v-speed-dial
            v-if="Boolean(panels) && !Boolean(action)"
            v-model="dials"
            fixed
            bottom
            right
            direction="top"
            transition="slide-y-reverse-transition"
        > 
            <template v-slot:activator>
                <v-btn
                    v-model="dials"    
                    dark
                    color="pink"
                    fab
                >
                    <v-icon v-if="dials">mdi-close</v-icon>
                    <v-icon v-else>mdi-dots-horizontal</v-icon>
                </v-btn>
            </template>
            
            <v-btn 
                v-if="action !== null"
                fab
                small
                color="red darken-1"
                dark
                @click="action = null"
            >
                <v-icon>mdi-cancel</v-icon>
            </v-btn>
            
            <v-btn 
                v-if="Boolean(enableDelete)"
                fab
                small
                color="red darken-1"
                dark
                @click="del"
            >
                <v-icon>mdi-delete</v-icon>
            </v-btn>

            <v-btn 
                v-if="Boolean(enableEdit)"
                fab
                small
                color="deep-purple darken-4"
                dark
                @click="edit"
            >
                <v-icon>mdi-square-edit-outline</v-icon>
            </v-btn>

            <!-- <v-btn 
                v-if="Boolean(meta.file)"
                fab
                small
                color="deep-purple darken-4"
                dark
                @click="save"
            >
                <v-icon>mdi-content-save</v-icon>
            </v-btn> -->

            <v-btn 
                v-if="action !== null"
                fab
                small
                color="red darken-1"
                dark
                @click="init"
            >
                <v-icon>mdi-cached</v-icon>
            </v-btn>
            
            <v-btn 
                v-if="enableAdd"
                fab
                small
                color="success"
                dark
                @click="add"
            >
                <v-icon>mdi-plus</v-icon>
            </v-btn>
        </v-speed-dial>

        <v-card-text class="pt-5">
            <v-expansion-panels
                v-model="panels"
                popout
                focusable
            >
                <v-expansion-panel>
                    <v-expansion-panel-header>Détails</v-expansion-panel-header>
                    <v-expansion-panel-content>
                        <v-card flat>
                            <v-list>
                                <v-list-item
                                    v-for="(info, key) in infos"
                                    :key="`info-${key}`"
                                >
                                    <v-row>
                                        <v-col cols="2">
                                            {{ key === 'client' ? 'Client' : key === 'desc' ? 'Description' : key }}:
                                        </v-col>

                                        <v-col>
                                            <a v-if="$p9.test.isUrl(info)" :href="info">{{ info }}</a>
                                            <span v-else>{{ info }}</span>
                                        </v-col>
                                    </v-row>
                                </v-list-item>
                            </v-list>
                        </v-card>
                    </v-expansion-panel-content>
                </v-expansion-panel>
                
                <v-expansion-panel>
                    <v-expansion-panel-header>Grilles de calcul</v-expansion-panel-header>
                    <v-expansion-panel-content>
                        <v-card flat>
                            <v-expand-transition>
                                <v-data-table
                                    v-if="action !== 'adding-1'"
                                    :headers="headers()"
                                    :items="calcs"
                                    v-model="selection"
                                    show-select
                                    @item-selected="itemSelected"
                                    :items-per-page="rpp"
                                >
                                    <template v-slot:item.mainframe="{ item }">
                                        <span>{{ getItemModelById(item.trx.mainframe) }}</span>
                                    </template>

                                    <template v-slot:item.price="{ item }">
                                        <span>{{ $p9.parse.money(item.context.totalCost) }}</span>
                                    </template>

                                    <template v-slot:item.lastUpdate="{ item }">
                                        <span>{{ day(item.lastUpdate.time) }}, {{ time(item.lastUpdate.time) }}</span>
                                    </template>
                                </v-data-table>
                            </v-expand-transition>
                            
                            <v-expand-transition>
                                <Calculator 
                                    v-if="action === 'adding-1'" 
                                    ref="calculator" 
                                    :document="document" 
                                    :collection="collection" 
                                    :updatedCalc="Boolean(this.selection.length) ? this.selection[0].id : null" 
                                    @close="closeDialog" 
                                    @prompt="prompt"
                                />
                            </v-expand-transition>
                        </v-card>
                    </v-expansion-panel-content>
                </v-expansion-panel>
            </v-expansion-panels>
        </v-card-text>
    </v-card>
</template>

<script>
import Calculator from '@/components/Calculator.vue'

export default {
    name: 'OpportunityDialog',
    props: [
        'document',
        'collection',
    ],
    components: {
        Calculator,
    },
    data: () => ({
        rpp: 10,
        panels: null,
        dials: false,
        action: null,
        loading: false,
        selection: [],
        meta: {},
        search: {
            text: null,
            vendor: null,
        },
    }),
    computed: {
        opportunity() {
            let collection = Object.entries(this.$store.state[this.collection].items)
            let opportunity = Boolean(collection.length) ? collection.filter(x => x[0] === this.document) : []
            return Boolean(opportunity.length) ? opportunity[0] : null
        },
        infos() {
            let data = Boolean(this.opportunity) ? this.opportunity[1] : {}
            let newObj = {}
            Object.keys(data).forEach(key => {
                if(!['author', 'calcs', 'updates'].includes(key)) newObj[key] = data[key]
            })
            
            return newObj
        },
        calcs() {
            let arr = []
            let data = this.$store.state[this.collection].items[this.document].calcs

            if(Boolean(data)) {
                Object.entries(data).forEach(entry => {
                    arr.push({id: entry[0], ...entry[1]})
                })
            }

            return arr
        },
        enableDelete() {
            return Boolean(this.selection.length)
        },
        enableEdit() {
            return this.selection.length === 1
        },
        enableAdd() {
            return !Boolean(this.enableEdit) && !Boolean(this.enableDelete)
        },
    },
    methods: {
        log(msg) {
            console.log(msg)
        },  
        day(isoStr) {
            return isoStr.split('T')[0]
        },
        time(isoStr) {
            return isoStr.split('T')[1].substring(0, 5)
        },
        getItemModelById(id) {
            let item = this.$store.state.items.items[id]

            return Boolean(item) ? item.model : null
        },
        prompt(msg) {
            this.$emit('prompt', msg)
        },
        clearSelection() {
            this.selection = []
        },
        itemSelected(e) {
            //console.log(e)
        },      
        headers(view) {
            let arr = []
            let headers = [
                'mainframe',
                'price',
                'lastUpdate',
            ]

            switch(view) {
                default:
                    headers.forEach(header => {
                        let target = this.$store.state[this.collection].calcHeaders.filter(item => item.value === header)[0]
                        if(Boolean(target)) arr.push(target)
                    })
            }
            
            return arr
        },
        add() {
            this.action = `adding-${ this.panels }`
        },
        edit() {
            this.action = `adding-${ this.panels }`
        },
        save(e) {   
            console.log(e)         
            /* this.$store.dispatch(`${this.collection}/set`, [id, {}])
                .then(() => { this.init() })
                .catch(err => { console.log(err.message) }) */
        },
        update(e) {
            console.log(e)   
            /* let doc = this.$store.state[this.collection].items[this.document]
            let data = [this.document]
            let newTarget = Boolean(doc[this.panels]) && Array.isArray(doc[this.panels]) ? doc[this.panels] : []

            newTarget.push(Object.fromEntries(Object.entries(this.meta)
                .filter(([k, v]) => v !== null)
                .map(([k, v]) => [k, v])
            ))

            data[1] = { [this.panels]: newTarget }

            this.$store.dispatch(`${this.collection}/update`, data)
                .then(() => { this.init() })
                .catch(err => { console.log(err.message) }) */
        },
        del() {  
            switch(this.panels) {
                case 1:
                    let opportunity = Object.entries(this.$store.state[this.collection].items).filter(x => x[0] === this.document)
                    opportunity = Boolean(opportunity.length) ? opportunity[0] : null

                    if(Boolean(opportunity)) {
                        this.selection.forEach(x => {
                            if(opportunity[1].calcs[x.id]) delete opportunity[1].calcs[x.id]
                        })

                        this.$store.dispatch(`${this.collection}/set`, opportunity)
                            .then(() => { this.init() })
                            .catch(err => { console.log(err.message) })
                        
                        this.selection = []
                    }
                    break
                
                default:
                    /* let arr = []

                    this.selection[this.selectionCollection].forEach(sel => { arr.push(sel.id) })

                    this.$store.dispatch(`${this.selectionCollection}/deleteBatch`, arr)
                        .then(() => { this.init() })
                        .catch(err => { console.log(err.message) })

                    this.selection[this.selectionCollection] = [] */
            }
        },
        init() {
            this.panels = null
            this.action = null
            this.loading = false
            this.meta = {}
        },
        closeDialog() {
            this.$refs.calculator.init()
            this.action = null
        },
        close() {
            this.init()
            this.$emit('close')
        },
    },
    mounted() {
        this.init()
    },
    destroyed() {
        this.init()
    }
}
</script>